import { useQuery } from 'react-query';
import { fmcsa } from '../../../API/TT_ELD/fmcsa';

export const useFMCSA = (status: string, skip: string | number) => {
  return useQuery([`fmcsaMain/${skip || 'all'}`, skip, status], () => fmcsa.read(status, skip), {
    refetchOnWindowFocus: false,
    refetchInterval: 5 * 60 * 1000,
  });
};

export const useFmcsaCount = (): any => {
  return useQuery([`fmcsaCount/all`], () => fmcsa.fmcsaCount(), {
    refetchOnWindowFocus: false,
    refetchInterval: 5 * 60 * 1000,
  });
};

export const useFmcsaFailedList = (skip: string | number) => {
  return useQuery([`fmcsaFailed/${skip || 'all'}`, skip], () => fmcsa.fmcsaFailedList(skip), {
    refetchOnWindowFocus: false,
    refetchInterval: 5 * 60 * 1000,
  });
};
